import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, ArrowUpRight } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-teal-dark text-white relative overflow-hidden">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif text-3xl md:text-4xl leading-[1.05]">Ducrot &amp; Associés</div>
            <p className="eyebrow text-teal-l3 mt-2">Expertise comptable &amp; conseils · Depuis 1968</p>
            <p className="text-teal-l3 mt-6 max-w-md text-sm leading-relaxed">
              Inscrit à l'Ordre des Experts-Comptables de Provence Alpes Côte d'Azur.
              Un cabinet à taille humaine pour entrepreneurs, TPE et PME.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-teal-l3 mb-4">Navigation</p>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-nav-home" to="/" className="hover:text-teal-l3">Accueil</Link></li>
              <li><Link data-testid="footer-nav-services" to="/services" className="hover:text-teal-l3">Nos services</Link></li>
              <li><Link data-testid="footer-nav-recruit" to="/recrutement" className="hover:text-teal-l3">Recrutement</Link></li>
              <li><Link data-testid="footer-nav-contact" to="/contact" className="hover:text-teal-l3">Contact</Link></li>
              <li><Link data-testid="footer-nav-login" to="/login" className="hover:text-teal-l3">Espace client</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-teal-l3 mb-4">Coordonnées</p>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-teal-l3 shrink-0" />
                <span>4 Allée du Lauzon, 84110 Vaison-la-Romaine<br /><span className="text-teal-l3">Bureau secondaire à Lunel</span></span>
              </li>
              <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-teal-l3 shrink-0" />
                <span>04 90 36 30 00</span>
              </li>
              <li className="flex gap-3"><Clock size={16} className="mt-0.5 text-teal-l3 shrink-0" />
                <span>Lun–Ven · 9h00 – 18h30</span>
              </li>
            </ul>
            <Link to="/contact" data-testid="footer-cta" className="mt-8 inline-flex items-center gap-2 border border-white/40 px-5 py-2.5 text-sm hover:bg-white hover:text-teal-dark transition-colors">
              Parlons de votre projet <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-white/15" data-testid="footer-partners">
          <p className="eyebrow text-teal-l3 mb-4">Nos partenaires</p>
          <ul className="flex flex-wrap gap-3">
            {[
              "Notaire",
              "Avocat fiscaliste",
              "Gestionnaire de communication",
            ].map((p) => (
              <li key={p} data-testid={`footer-partner-${p.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-xs eyebrow border border-white/25 px-3 py-2 hover:border-white/60 transition-colors">
                {p}
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs text-teal-l3 max-w-3xl">
            Nous coordonnons vos opérations complexes en lien avec un réseau de partenaires
            de confiance : notaires, avocats fiscalistes et gestionnaires de communication.
          </p>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col md:flex-row justify-between text-xs text-teal-l3 gap-3">
          <div>© 2026 Ducrot &amp; Associés. Tous droits réservés.</div>
          <div className="flex gap-6">
            <a href="/mentions-legales" className="hover:text-white">Mentions légales</a>
            <a href="/confidentialite" className="hover:text-white">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
